export function queryHref (key) {
  let data = window.location.href.split('?')
  let value = null
  if (!data[1]) {
    return null
  }
  data = data[1].split('&')
  data.forEach(str => {
    let arr = str.split('=')
    if (key === arr[0]) {
      value = arr[1]
    }
  })
  return value
}


// WEBPACK FOOTER //
// ./src/common/utils.js